import React from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import { Redirect } from 'react-router-dom'
import Loader from '../../components/Loader/Loader'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import VerifyPhoneForm from '../../components/Form/VerifyPhoneForm/VerifyPhoneForm'
import { userActions } from '../../redux/actions'
import { currentUser } from '../../redux/reducers/user.reducers'
import ResendPhoneCode from './ResendPhoneCode'
import ResendEmailVerificationCode from './ResendEmailVerificationCode'
import SubmitPhone from '../../components/SubmitPhone/SubmitPhone'

class ActivateAccount extends React.Component {
  onPhoneVerification({ code }) {
    const { user } = this.props
    const verification = {
      code,
      // eslint-disable-next-line camelcase
      user_id: user.id,
    }
    // TODO: Make protected route
    return this.props.verifyPhoneNumber(verification)
  }

  renderVerificationStep() {
    const {
      user,
      user: {
        user_detail: { phone, emailVerified },
      },
    } = this.props

    if (!emailVerified) {
      return (
        <div>
          <ResendEmailVerificationCode user={user} />
        </div>
      )
    }

    if (phone) {
      return (
        <div>
          <VerifyPhoneForm onSubmit={data => this.onPhoneVerification(data)} phone={phone} />
          <ResendPhoneCode user={user} />
        </div>
      )
    }

    return (
      <div style={{ marginTop: '5rem', marginBottom: '5rem' }}>
        <h4 id="activation-message-heading">
          <FormattedMessage id="page.activationPage.activationMessage.emailOnly" />
        </h4>
        <FormattedMessage id="page.activationPage.activationMessage.AddPhone" />
        <SubmitPhone />
      </div>
    )
  }

  render() {
    const {
      user,
      user: {
        user_detail: { emailVerified, phoneVerified },
      },
    } = this.props

    if (!user) {
      return <Loader noBodrder />
    }

    if (emailVerified && phoneVerified) {
      return <Redirect to="/" />
    }

    const label = this.props.intl.formatMessage({ id: 'page.activationPage.title.heroTitle' })

    return (
      <div className="reset-password-page" aria-labelledby="activation-hero-title">
        <Helmet>
          <title>{label}</title>
        </Helmet>

        <div className="container mt-5 mb-5">
          <h1 className="page-title" id="activation-hero-title">
            <FormattedMessage id="page.activationPage.title.heroTitle" />
          </h1>
          {!emailVerified && (
            <div>
              <h4>
                <FormattedMessage id="page.activationPage.title.description" />
              </h4>
              <p>
                <FormattedMessage id="page.activationPage.title.note" />
              </p>
            </div>
          )}
          <div className="row justify-content-left">
            <div className="col-md-8 col-xl-6">{this.renderVerificationStep()}</div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: currentUser(state),
})

const { verifyPhoneNumber, verifyEmail } = userActions
const mapDispatchToProps = { verifyPhoneNumber, verifyEmail }
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ActivateAccount))
